<template>
    <div class="receive">
        <div class="list">
            <div class="flex item" v-for="(item,index) in list" :key="index">
                <img src="@/assets/images/coupon1.png" alt="">
                <div class="flex item__left">
                    <div class="flex__center__around item__left__left">
                        <span class="fs_50 c_main"><span class="fs_24">¥</span>{{item.price}}</span>
                        <span class="fs_20 c_main">满{{item.coupon_limit}}元可用</span>
                    </div>
                    <div class="flex__null__around item__left__right">
                        <span class="fs_30 c_1a ellipsis_one">{{item.name}}</span>
                        <span class="fs_22 c_80 ellipsis_one">{{item.brief}}</span>
                        <span class="fs_20 c_80">{{item.validity_time}}</span>
                    </div>
                </div>
                <div class="flex__center__around item__right">
                    <span class="fs_22 c_ff">消耗积分</span>
                    <span class="fs_30 c_ff">{{item.integral}}</span>
                    <button @click="receive(index)">立即兑换</button>
                </div>
            </div>
        </div>
        <div class="flex__center__center footer" v-link="'/Coupon/Index'">
            <span class="fs_32 c_66">查看我的优惠券</span>
        </div>
        <jc-list :url="'/Coupon/getExchangeCouponList'" :loads="loads" @load='getList' v-if="refresh"></jc-list>
    </div>
</template>
<script>
export default {
    name:"Receive",
    data(){
        return{
            refresh: true, //刷新组件用
            list: [],
            loads:{
                user_id: localStorage.user_id,
                page:1 
            }
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        },
        receive(index){
            this.axios.post('/wechat.php/Coupon/receiveExchangeCoupe',{
                user_id: localStorage.user_id,
                coupon_id: this.list[index].id
            }).then(
                res=>{
                    this.$toast(res.data.message);
                }
            )
        }
    },
    mounted(){

    }
}
</script>
<style scoped>
.list{
    padding: 0 30px;
}
.item{
    position: relative;
    height: 160px;
    margin-top: 30px;
    border-radius: 10px;
    box-shadow:0px 0px 10px 0px rgba(230,230,230,1);
}
.item img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.item__left{
    position: absolute;
    left: 0;
    width: 540px;
    height: 160px;
    padding: 20px 0;
}
.item__left__left{
    width: 160px;
    border-right: 2px dashed #e6e6e6;
}
.item__left__right{
    width: 380px;
    margin-left: 30px;
}
.item__right{
    position: absolute;
    right: 0;
    width: 150px;
    height: 160px;
}
.item__right button{
    width: 120px;
    height: 40px;
    border-radius: 20px;
    background: #fff;
    font-size: 22px;
    color: #F93A42;
}
.footer{
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 98px;
    background: #fff;
}
</style>





// WEBPACK FOOTER //
// src/pages/coupon/Give.vue